import {LazyAsync, RestClient} from "zavadil-ts-common";
import {RegionView} from "../../types/Region";

export class RegionsClient {

	client: RestClient;

	lazy: LazyAsync<Array<RegionView>>;

	constructor(client: RestClient) {
		this.client = client;

		this.lazy = new LazyAsync(() => this.client.getJson('region/all'));
	}

	all(): Promise<Array<RegionView>> {
		return this.lazy.get();
	}

	load(regionId: number): Promise<RegionView | undefined> {
		return this.all().then((regions) => regions.find((r) => r.id === regionId));
	}
}
